exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mdm-modal-ecopart-body{font-size:14px;font-size:.875rem;line-height:2rem}", ""]);

